import { fetchAppAPI } from "../../utils/api";
import { compoundCreditRatingFormatter } from "../../utils/formatters";

const getFeaturedInstruments = (feature, boundary) => {
    return new Promise(async (resolve, reject) => {
        try {
            const params = "/instruments/featured/" + feature
            const query = `boundary=${boundary}`
            const data = await fetchAppAPI(params, query)
            resolve(data.map((instrument) => {
                return ({
                    ...instrument,
                    maturity: new Date(instrument.maturity),
                });
            }))
        } catch (e) {
            reject(e)
        }
    })
}

const getInstrumentDetail = async (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            const params = "/instruments/detail/" + id
            const data = await fetchAppAPI(params)
            resolve({
                ...data,
                creditRating: compoundCreditRatingFormatter(data.moodysRatingCode, data.standardPoorsRatingCode, data.fitchRatingCode),
                moodysLastUpdated: new Date(data.moodysLastUpdated),
                standardPoorsLastUpdated: new Date(data.standardPoorsLastUpdated),
                fitchLastUpdated: new Date(data.fitchLastUpdated),
                firstSessionDate: new Date(data.firstSessionDate),
                lastSessionDate: new Date(data.lastSessionDate),
                maturity: new Date(data.maturity),
                price: data.price ?? 0,
                yield: data.yield ?? 0,
                rate: data.rate ?? 0,
            })
        } catch (e) {
            reject(e)
        }
    })
}

const getInstrumentSummary = async (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            const params = "/instruments/summary/" + id
            const data = await fetchAppAPI(params)
            resolve({
                ...data,
                creditRating: compoundCreditRatingFormatter(data.moodysRatingCode, data.standardPoorsRatingCode, data.fitchRatingCode),
                maturity: new Date(data.maturity),
                firstSessionDate: new Date(data.firstSessionDate),
                lastSessionDate: new Date(data.lastSessionDate),
                price: data.price ?? 0,
                yield: data.yield ?? 0,
                rate: data.rate ?? 0,
            })
        } catch (e) {
            reject(e)
        }
    })
}

const instrumentSearchSuggestions = async (term) => {
    return new Promise(async (resolve, reject) => {
        try {
            const params = "/instruments/search/" + term
            const data = await fetchAppAPI(params)
            resolve(data.map((suggestion) => {
                return ({
                    ...suggestion,
                    maturity: new Date(suggestion.maturity),
                    creditRating: compoundCreditRatingFormatter(suggestion.moodysRatingCode, suggestion.standardPoorsRatingCode, suggestion.fitchRatingCode)
                })
            }))
        } catch (e) {
            reject(e)
        }
    })
}

const getAllInstruments = async (lastRetrievedIndex, limit, retrieveAll, searchTerm, sortParam, descSort) => {
    return new Promise(async (resolve, reject) => {
        try {
            const params = "/instruments/all"
            const query = `lastRetrievedIndex=${lastRetrievedIndex}&limit=${limit}&retrieveAll=${retrieveAll}&searchTerm=${searchTerm}&sortParam=${sortParam}&descSort=${descSort}`
            const data = await fetchAppAPI(params, query)
            resolve(data.map((instrument) => {
                return ({
                    ...instrument,
                    maturity: new Date(instrument.maturity),
                    firstSessionDate: new Date(instrument.firstSessionDate),
                    lastSessionDate: new Date(instrument.lastSessionDate),
                })
            }))
        } catch (e) {
            reject(e)
        }
    })
}


export {
    getFeaturedInstruments,
    getInstrumentDetail,
    getInstrumentSummary,
    instrumentSearchSuggestions,
    getAllInstruments,
}